import React, { PropTypes, PureComponent } from 'react';
import _throttle from 'lodash/throttle';
import appConfig from 'config';
import WatchPropTypes from 'common/PropTypes';
import connectPlayer from 'webapp/player/connectPlayer';
import PlayerOverlay from '../PlayerOverlay';
import styles from './style';
import { HEADER_HEIGHT } from '../PlayerOverlay/style';

const {
    secureCdnHost
} = appConfig;

const networkToImageName = { espn1: 'espn' };

class Player extends PureComponent {
    constructor(props) {
        super(props);
        this.onPlayerMouseMove = this.onPlayerMouseMove.bind(this);
        this.processMouseMove = _throttle(this.processMouseMove.bind(this), 100);
        this.state = {
            showOverlay: false
        };
    }

    onPlayerMouseMove(event) {
        if (this.props.socialOpened || this.props.captionOpened) {
            return;
        }
        const { nativeEvent: { pageY } } = event;
        this.processMouseMove(pageY);
    }

    processMouseMove(pageY) {
        const showOverlay = pageY <= HEADER_HEIGHT;
        if (this.state.showOverlay !== showOverlay) {
            this.setState({ showOverlay });
        }
    }

    render() {
        const {
            location,
            branding,
            provider,
            selectedStream,
            playingStream,
            render,
            handleLogout
        } = this.props;

        const stream = playingStream || selectedStream || {};
        const { name, source: { id: sourceId, name: sourceOrig = '' } = {} } = stream;
        const source = (sourceId || sourceOrig).toLowerCase();
        const networkLogoName = networkToImageName[source] || source;
        const logoUrl = networkLogoName ?
            `${secureCdnHost}/watchespn/images/web/network_logos/channel_logo_${networkLogoName}_2x.png` : null;
        const sourceObj = {
            name: sourceId || source,
            logoUrl
        };

        return (
            <div
                ref={(el) => { this.container = el; }}
                className="player-container"
                style={render ? styles.container : { display: 'none' }}
                onMouseMove={render && this.onPlayerMouseMove}
            >
                {render && (
                    <PlayerOverlay
                        show={this.state.showOverlay}
                        name={name}
                        source={sourceObj}
                        branding={branding}
                        location={location}
                        provider={provider}
                        handleLogout={handleLogout}
                    />
                )}
                <div
                    ref="playerContainer"
                    id="watchespn-player-container"
                    style={styles.player}
                />
            </div>
        );
    }
}

Player.propTypes = {
    branding: PropTypes.object,
    selectedStream: WatchPropTypes.stream,
    playingStream: WatchPropTypes.stream,
    location: PropTypes.object,
    provider: PropTypes.object,
    render: PropTypes.bool,
    socialOpened: PropTypes.bool,
    captionOpened: PropTypes.bool,
    handleLogout: PropTypes.func
};

export default connectPlayer(Player);



// WEBPACK FOOTER //
// ./app/webapp/syndicated/ConnectedPlayer/index.js